import { Injectable, EventEmitter } from "@angular/core";

import * as _ from "lodash";

import { DialogSettings } from "./dialog.base";
import { Dialog } from "./dialog.base";

/**
 * @ignore
 */
@Injectable()
export class DialogBaseService {
  /**
   * @ignore
   */
  constructor() {
    document.addEventListener(
      "keydown",
      event => {
        const keyCode = event.which || event.keyCode;
        if (
          [
            13, // Return
            27 // Escape
          ].indexOf(keyCode) > -1
        ) {
          const visible_dialogs = this.dialogs.filter(dialog => dialog.visible);
          if (visible_dialogs.length > 0) {
            // const is_escape = keyCode == 27;
            // const is_return = keyCode == 13;
            const last_visible_dialogs = _.last(visible_dialogs);
            let handler = null;
            if (!last_visible_dialogs.settings.keyboard) return;
            switch (keyCode) {
              case 13:
                handler = last_visible_dialogs.settings.keyboard.onReturn;
                break;
              case 27:
                handler = last_visible_dialogs.settings.keyboard.onEscape;
                break;
            }
            if (_.isFunction(handler)) {
              handler();
            } else {
              switch (handler) {
                case "close":
                  event.preventDefault();
                  last_visible_dialogs.close();
                  break;
                case "dismiss":
                  event.preventDefault();
                  last_visible_dialogs.dismiss();
                  break;
                default:
                  return;
              }
            }
          }
        }
      },
      true
    );
  }

  public dialogs: Array<Dialog> = [];

  public onShow: EventEmitter<Dialog> = new EventEmitter();
  public onHide: EventEmitter<Dialog> = new EventEmitter();

  private _current_index: number = 0;

  private _zindex: number = 10010;
  private _content_zindex: number = 10020;
  private _backdrop_zindex: number = 10000;

  public get visibleDialogs(): Array<Dialog> {
    return this.dialogs.filter(dialog => dialog.visible);
  }

  public create(
    component: any,
    params?: any,
    settings?: DialogSettings
  ): Dialog {
    if (!(params && _.isPlainObject(params))) params = {};
    let data = {
      component: component,
      params: params,
      settings: settings,
      zindex: this._zindex,
      content_zindex: this._content_zindex,
      backdrop_zindex: this._backdrop_zindex
    };

    this._zindex += 100;
    this._content_zindex += 100;
    this._backdrop_zindex += 100;

    const dialog_instance = new Dialog(this, data, this._current_index);

    this._current_index++;

    return dialog_instance;
  }

  public open(component: any, params?: any, settings?: DialogSettings): Dialog {
    if (!(params && _.isPlainObject(params))) params = {};
    let instance = this.create(component, params, settings);
    instance.open();
    return instance;
  }
}
